import * as hyejoo from './hyejoo';
import * as models from './models';

export const {
    getAll: Carriers,
    get: Carrier,
} = hyejoo.Getters('/carriers', resp => models.CarriersHyejooResponse.fromJSON(resp).carriers);
